import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TextBook } from '@core/entities';
import { ITextBook } from '@core/interfaces';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TextbookService {
  constructor(private http: HttpClient) {}

  /**
   * Get all textbooks
   */
  getAllTextbooks(): Observable<TextBook[]> {
    return this.http
      .get<ITextBook[]>(`${environment.apiUrl}textbooks/`)
      .pipe(
        map((textbooks: ITextBook[]) =>
          textbooks.map((textbook: ITextBook) => new TextBook(textbook))
        )
      );
  }

  /**
   * Get textbooks filtered by simulation
   */
  getTextbooksBySimulation(simulationId: number): Observable<TextBook[]> {
    return this.http
      .get<ITextBook[]>(`${environment.apiUrl}textbooks/?simulation=${simulationId}`)
      .pipe(
        map((textbooks: ITextBook[]) =>
          textbooks.map((textbook: ITextBook) => new TextBook(textbook))
        )
      );
  }

  /**
   * Get specific textbook by UUID
   */
  getTextbookDetail(uuid: string): Observable<TextBook> {
    return this.http
      .get<ITextBook>(`${environment.apiUrl}textbooks/${uuid}/`)
      .pipe(map((textbook: ITextBook) => new TextBook(textbook)));
  }

  /**
   * Get textbook content proxy URL
   * @param uuid - Textbook UUID
   * @param path - Path to content (e.g., 'PB_DDAYguide_html.html')
   */
  getTextbookContentUrl(uuid: string, path: string = ''): string {
    return `${environment.apiUrl}textbook/${uuid}/${path}`;
  }
}
